// carryForwardProps.js — PURE helper for the Image block's "carry forward last
// style" mount effect (see index.jsx). No React, no craft.js, no Redux: just a
// deterministic patch-computation so the field list is unit-testable in
// isolation and the leak fixed in WEB-034 can't silently regress.
//
// WEB-034 (audits/FINDINGS-REGISTER.md): the mount effect used to also copy
// `hyperlink` / `showHyperlink` from the shared "last used" store onto a
// brand-new block. That's a click DESTINATION — content, not decoration — and
// every other content field in this codebase (image src, video src, text
// copy, linked Wheel id) is deliberately excluded from carry-forward with a
// comment explaining why. `hyperlink`/`showHyperlink` were the one exception,
// missed. They are intentionally NOT in the patch below.
//
// Only fields that are currently `undefined` on `props` (i.e. a genuinely new
// block, per craft.js's own `ImageDefaultProps`) are ever copied forward.

export const getImageCarryForwardPatch = (props, imageProps) => {
  const patch = {};

  if (props.margin === undefined) {
    patch.margin = { ...imageProps.margin };
  }

  if (props.isApplyMarginOnAllSides === undefined) {
    patch.isApplyMarginOnAllSides = imageProps.isApplyMarginOnAllSides;
  }

  if (props.allSideMargin === undefined) {
    patch.allSideMargin = imageProps.allSideMargin;
  }

  if (props.width === undefined) {
    patch.width = imageProps.width;
  }

  if (props.borderRadius === undefined) {
    patch.borderRadius = imageProps.borderRadius;
  }

  if (props.borderWidth === undefined) {
    patch.borderWidth = imageProps.borderWidth;
  }

  if (props.borderColor === undefined) {
    patch.borderColor = imageProps.borderColor || "suggested_color_0";
  }

  if (props.dropShadowColor === undefined) {
    patch.dropShadowColor = imageProps.dropShadowColor;
  }

  if (props.alignment === undefined) {
    patch.alignment = imageProps.alignment;
  }

  if (props.showImageTitle === undefined) {
    patch.showImageTitle = imageProps.showImageTitle;
  }

  // WEB-034: hyperlink / showHyperlink are content (a click destination), not
  // style — deliberately excluded from carry-forward. Do not add them back
  // without a product decision; see audits/block-style-carryforward-assessment.md §3.5.

  return patch;
};
